import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './AdminPage.css';
import Billede1 from '../../Images/Billede1.jpg';
import HeroSectionV2 from '../../components/HeroSectionV2';
import MenuComponent from '../../components/MenuComponent';

const Home: React.FC = () => {
    const { language } = useLanguage();

    return (
        <div className="home">
            <HeroSectionV2
                titleEn="Admin"
                titleDa="Admin"
                descriptionEn="Welcome to the volunteer adminportal"
                descriptionDa="Velkommen til admin frivilligportalen"
                imageSrc={Billede1}
            />
            <section className="events-section">
                <MenuComponent itemsToShow={[1, 2, 4, 6, 9, 10, 11, 12, 14, 15, 16, 18, 5, 7,22,50,49,100,101]} />
            </section>
        </div>
    );
};

export default Home;
